export class NonUserModel implements INonUserModel {
    userId?: number;
    userName: string | undefined;

    constructor(data?: INonUserModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.userName = _data['userName'];
        }
    }

    static fromJS(data: any): NonUserModel {
        data = typeof data === 'object' ? data : {};
        const result = new NonUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['userName'] = this.userName;
        return data;
    }
}

export interface INonUserModel {
    userId?: number;
    userName?: string | undefined;
}

export class RoleCompanyModel implements IRoleCompanyModel {
    roleId?: number;
    roleName?: string | undefined;
    companies?: CompaniesModel[] | undefined;
    hasAllCompanies?: boolean;

    constructor(data?: IRoleCompanyModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data['roleId'];
            this.roleName = _data['roleName'];
            if (Array.isArray(_data['companies'])) {
                this.companies = [] as any;
                for (const item of _data['companies'])
                    {this.companies.push(CompaniesModel.fromJS(item));}
            }
            this.hasAllCompanies = _data['hasAllCompanies'];
        }
    }

    static fromJS(data: any): RoleCompanyModel {
        data = typeof data === 'object' ? data : {};
        const result = new RoleCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleId'] = this.roleId;
        data['roleName'] = this.roleName;
        if (Array.isArray(this.companies)) {
            data['companies'] = [];
            for (const item of this.companies)
                {data['companies'].push(item.toJSON());}
        }
        data['hasAllCompanies'] = this.hasAllCompanies;
        return data;
    }
}

export interface IRoleCompanyModel {
    roleId?: number;
    roleName?: string | undefined;
    companies?: CompaniesModel[] | undefined;
    hasAllCompanies?: boolean;
}

export class UserRoleMappingRequest implements IUserRoleMappingRequest {
    userIds!: number[];
    roleList!: number[];

    constructor(data?: IUserRoleMappingRequest) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
        if (!data) {
            this.userIds = [];
            this.roleList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['userIds'])) {
                this.userIds = [] as any;
                for (const item of _data['userIds'])
                    {this.userIds.push(item);}
            }
            if (Array.isArray(_data['roleList'])) {
                this.roleList = [] as any;
                for (const item of _data['roleList'])
                    {this.roleList.push(item);}
            }
        }
    }

    static fromJS(data: any): UserRoleMappingRequest {
        data = typeof data === 'object' ? data : {};
        const result = new UserRoleMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data['userIds'] = [];
            for (const item of this.userIds)
                {data['userIds'].push(item);}
        }
        if (Array.isArray(this.roleList)) {
            data['roleList'] = [];
            for (const item of this.roleList)
                {data['roleList'].push(item);}
        }
        return data;
    }
}

export interface IUserRoleMappingRequest {
    userIds: number[];
    roleList: number[];
}

export class UserRoleModel implements IUserRoleModel {
    roleId!: number;
    userId: number[] | undefined;

    constructor(data?: IUserRoleModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data['roleId'];
            if (Array.isArray(_data['userId'])) {
                this.userId = [] as any;
                for (const item of _data['userId'])
                    {this.userId.push(item);}
            }
        }
    }

    static fromJS(data: any): UserRoleModel {
        data = typeof data === 'object' ? data : {};
        const result = new UserRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleId'] = this.roleId;
        if (Array.isArray(this.userId)) {
            data['userId'] = [];
            for (const item of this.userId)
                {data['userId'].push(item);}
        }
        return data;
    }
}

export interface IUserRoleModel {
    roleId: number;
    userId: number[] | undefined;
}


export class CompanyModel implements ICompanyModel {
    companyId?: number;
    companyName?: string | undefined;

    constructor(data?: ICompanyModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data['companyId'];
            this.companyName = _data['companyName'];
        }
    }

    static fromJS(data: any): CompanyModel {
        data = typeof data === 'object' ? data : {};
        const result = new CompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['companyId'] = this.companyId;
        data['companyName'] = this.companyName;
        return data;
    }
}

export interface ICompanyModel {
    companyId?: number;
    companyName?: string | undefined;
}

export class GridResponseBaseOfCompanyModel implements IGridResponseBaseOfCompanyModel {
    items?: CompanyModel[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IGridResponseBaseOfCompanyModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (const item of _data['items'])
                    {this.items.push(CompanyModel.fromJS(item));}
            }
            this.totalRecordCount = _data['totalRecordCount'];
            this.pageNumber = _data['pageNumber'];
            this.pageSize = _data['pageSize'];
        }
    }

    static fromJS(data: any): GridResponseBaseOfCompanyModel {
        data = typeof data === 'object' ? data : {};
        const result = new GridResponseBaseOfCompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (const item of this.items)
                {data['items'].push(item.toJSON());}
        }
        data['totalRecordCount'] = this.totalRecordCount;
        data['pageNumber'] = this.pageNumber;
        data['pageSize'] = this.pageSize;
        return data;
    }
}

export interface IGridResponseBaseOfCompanyModel {
    items?: CompanyModel[] | undefined;
    totalRecordCount?: number;
    pageNumber?: number;
    pageSize?: number;
}

export class ScreenUser implements IScreenUser {
    userId?: number;
    userName?: string | undefined;
    roles?: ScreenRole[] | undefined;
    objectId?: string | undefined;

    constructor(data?: IScreenUser) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.userName = _data['userName'];
            if (Array.isArray(_data['roles'])) {
                this.roles = [] as any;
                for (const item of _data['roles'])
                    {this.roles.push(ScreenRole.fromJS(item));}
            }
            this.objectId = _data['objectId'];
        }
    }

    static fromJS(data: any): ScreenUser {
        data = typeof data === 'object' ? data : {};
        const result = new ScreenUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['userName'] = this.userName;
        if (Array.isArray(this.roles)) {
            data['roles'] = [];
            for (const item of this.roles)
                {data['roles'].push(item.toJSON());}
        }
        data['objectId'] = this.objectId;
        return data;
    }
}

export interface IScreenUser {
    userId?: number;
    userName?: string | undefined;
    roles?: ScreenRole[] | undefined;
    objectId?: string | undefined;
}


export class ScreenRole implements IScreenRole {
    roleId?: number;
    roleName?: string | undefined;
    canImpersonate?: boolean;
    companies?: ScreenCompany[] | undefined;
    screens?: Screens[] | undefined;

    constructor(data?: IScreenRole) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data['roleId'];
            this.roleName = _data['roleName'];
            this.canImpersonate = _data['canImpersonate'];
            if (Array.isArray(_data['companies'])) {
                this.companies = [] as any;
                for (const item of _data['companies'])
                    {this.companies.push(ScreenCompany.fromJS(item));}
            }
            if (Array.isArray(_data['screens'])) {
                this.screens = [] as any;
                for (const item of _data['screens'])
                    {this.screens.push(Screens.fromJS(item));}
            }
        }
    }

    static fromJS(data: any): ScreenRole {
        data = typeof data === 'object' ? data : {};
        const result = new ScreenRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleId'] = this.roleId;
        data['roleName'] = this.roleName;
        data['canImpersonate'] = this.canImpersonate;
        if (Array.isArray(this.companies)) {
            data['companies'] = [];
            for (const item of this.companies)
                {data['companies'].push(item.toJSON());}
        }
        if (Array.isArray(this.screens)) {
            data['screens'] = [];
            for (const item of this.screens)
                {data['screens'].push(item.toJSON());}
        }
        return data;
    }
}

export interface IScreenRole {
    roleId?: number;
    roleName?: string | undefined;
    canImpersonate?: boolean;
    companies?: ScreenCompany[] | undefined;
    screens?: Screens[] | undefined;
}


export class ScreenCompany implements IScreenCompany {
    companyID?: number;
    companyName?: string | undefined;

    constructor(data?: IScreenCompany) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyID = _data['companyID'];
            this.companyName = _data['companyName'];
        }
    }

    static fromJS(data: any): ScreenCompany {
        data = typeof data === 'object' ? data : {};
        const result = new ScreenCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['companyID'] = this.companyID;
        data['companyName'] = this.companyName;
        return data;
    }
}

export interface IScreenCompany {
    companyID?: number;
    companyName?: string | undefined;
}


export class Screens implements IScreens {
    screenId?: number;
    parentId?: number | undefined;
    displayOrder?: number | undefined;
    screenName?: string | undefined;
    screenCode?: string | undefined;
    path?: string | undefined;
    cssClass?: string | undefined;
    display?: boolean;
    isAuthorized?: boolean;
    permissions?: ScreenPermission[] | undefined;

    constructor(data?: IScreens) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.screenId = _data['screenId'];
            this.parentId = _data['parentId'];
            this.displayOrder = _data['displayOrder'];
            this.screenName = _data['screenName'];
            this.screenCode = _data['screenCode'];
            this.path = _data['path'];
            this.cssClass = _data['cssClass'];
            this.display = _data['display'];
            this.isAuthorized = _data['isAuthorized'];
            if (Array.isArray(_data['permissions'])) {
                this.permissions = [] as any;
                for (const item of _data['permissions'])
                    {this.permissions.push(ScreenPermission.fromJS(item));}
            }
        }
    }

    static fromJS(data: any): Screens {
        data = typeof data === 'object' ? data : {};
        const result = new Screens();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['screenId'] = this.screenId;
        data['parentId'] = this.parentId;
        data['displayOrder'] = this.displayOrder;
        data['screenName'] = this.screenName;
        data['screenCode'] = this.screenCode;
        data['path'] = this.path;
        data['cssClass'] = this.cssClass;
        data['display'] = this.display;
        data['isAuthorized'] = this.isAuthorized;
        if (Array.isArray(this.permissions)) {
            data['permissions'] = [];
            for (const item of this.permissions)
                {data['permissions'].push(item.toJSON());}
        }
        return data;
    }
}

export interface IScreens {
    screenId?: number;
    parentId?: number | undefined;
    displayOrder?: number | undefined;
    screenName?: string | undefined;
    screenCode?: string | undefined;
    path?: string | undefined;
    cssClass?: string | undefined;
    display?: boolean;
    isAuthorized?: boolean;
    permissions?: ScreenPermission[] | undefined;
}


export class ScreenPermission implements IScreenPermission {
    permissionId?: number;
    permissionName?: string | undefined;

    constructor(data?: IScreenPermission) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data['permissionId'];
            this.permissionName = _data['permissionName'];
        }
    }

    static fromJS(data: any): ScreenPermission {
        data = typeof data === 'object' ? data : {};
        const result = new ScreenPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['permissionId'] = this.permissionId;
        data['permissionName'] = this.permissionName;
        return data;
    }
}

export interface IScreenPermission {
    permissionId?: number;
    permissionName?: string | undefined;
}

export class UserModel implements IUserModel {
    userRoleId?: number;
    userId?: number;
    userName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userRoleId = _data['userRoleId'];
            this.userId = _data['userId'];
            this.userName = _data['userName'];
            this.email = _data['email'];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        const result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userRoleId'] = this.userRoleId;
        data['userId'] = this.userId;
        data['userName'] = this.userName;
        data['email'] = this.email;
        return data;
    }
}

export interface IUserModel {
    userRoleId?: number;
    userId?: number;
    userName?: string | undefined;
    email?: string | undefined;
}

export class UserRoleCompany implements IUserRoleCompany {
    userId?: string | undefined;
    companyId?: number;
    roleId?: number[] | undefined;

    constructor(data?: IUserRoleCompany) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(<any>this)[property] = (<any>data)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.companyId = _data['companyId'];
            if (Array.isArray(_data['roleId'])) {
                this.roleId = [] as any;
                for (const item of _data['roleId'])
                    {this.roleId.push(item);}
            }
        }
    }

    static fromJS(data: any): UserRoleCompany {
        data = typeof data === 'object' ? data : {};
        const result = new UserRoleCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['companyId'] = this.companyId;
        if (Array.isArray(this.roleId)) {
            data['roleId'] = [];
            for (const item of this.roleId)
                {data['roleId'].push(item);}
        }
        return data;
    }
}

export interface IUserRoleCompany {
    userId?: string | undefined;
    companyId?: number;
    roleId?: number[] | undefined;
}

export class CompaniesModel implements ICompaniesModel {
    companyId?: number;
    companyName?: string | undefined;
    isSelected?: boolean;

    constructor(data?: ICompaniesModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(this as any)[property] = (data as any)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data['companyId'];
            this.companyName = _data['companyName'];
            this.isSelected = _data['isSelected'];
        }
    }

    static fromJS(data: any): CompaniesModel {
        data = typeof data === 'object' ? data : {};
        const result = new CompaniesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['companyId'] = this.companyId;
        data['companyName'] = this.companyName;
        data['isSelected'] = this.isSelected;
        return data;
    }
}

export interface ICompaniesModel {
    companyId?: number;
    companyName?: string | undefined;
    isSelected?: boolean;
}

export class ADUserModel implements IADUserModel {
    objectId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;

    constructor(data?: IADUserModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(this as any)[property] = (data as any)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data['objectId'];
            this.name = _data['name'];
            this.email = _data['email'];
            this.jobTitle = _data['jobTitle'];
        }
    }

    static fromJS(data: any): ADUserModel {
        data = typeof data === 'object' ? data : {};
        const result = new ADUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['objectId'] = this.objectId;
        data['name'] = this.name;
        data['email'] = this.email;
        data['jobTitle'] = this.jobTitle;
        return data;
    }
}

export interface IADUserModel {
    objectId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;
}

export class FilterRequest implements IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    appendUsername?: boolean;

    constructor(data?: IFilterRequest) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(this as any)[property] = (data as any)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data['sortColumn'];
            this.sortDirection = _data['sortDirection'];
            this.filterColumn = _data['filterColumn'];
            this.filterValue = _data['filterValue'];
            this.pageSize = _data['pageSize'];
            this.pageNumber = _data['pageNumber'];
            this.filterType = _data['filterType'];
            this.appendUsername = _data['appendUsername'];
        }
    }

    static fromJS(data: any): FilterRequest {
        data = typeof data === 'object' ? data : {};
        const result = new FilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['sortColumn'] = this.sortColumn;
        data['sortDirection'] = this.sortDirection;
        data['filterColumn'] = this.filterColumn;
        data['filterValue'] = this.filterValue;
        data['pageSize'] = this.pageSize;
        data['pageNumber'] = this.pageNumber;
        data['filterType'] = this.filterType;
        data['appendUsername'] = this.appendUsername;
        return data;
    }
}

export interface IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    appendUsername?: boolean;
}

export class ResponseModel implements IResponseModel {
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IResponseModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(this as any)[property] = (data as any)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data['isSuccess'];
            this.message = _data['message'];
        }
    }

    static fromJS(data: any): ResponseModel {
        data = typeof data === 'object' ? data : {};
        const result = new ResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isSuccess'] = this.isSuccess;
        data['message'] = this.message;
        return data;
    }
}

export interface IResponseModel {
    isSuccess?: boolean;
    message?: string | undefined;
}

export class RoleModel implements IRoleModel {
    roleId?: number;
    roleName!: string;
    companies?: CompaniesModel[] | undefined;
    screens?: ScreensModel[] | undefined;
    hasAllCompanies?: boolean;
    canImpersonate?: boolean;

    constructor(data?: IRoleModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(this as any)[property] = (data as any)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data['roleId'];
            this.roleName = _data['roleName'];
            if (Array.isArray(_data['companies'])) {
                this.companies = [] as any;
                for (const item of _data['companies'])
                    {this.companies?.push(CompaniesModel.fromJS(item));}
            }
            if (Array.isArray(_data['screens'])) {
                this.screens = [] as any;
                for (const item of _data['screens'])
                    {this.screens?.push(ScreensModel.fromJS(item));}
            }
            this.hasAllCompanies = _data['hasAllCompanies'];
            this.canImpersonate = _data['canImpersonate'];
        }
    }

    static fromJS(data: any): RoleModel {
        data = typeof data === 'object' ? data : {};
        const result = new RoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleId'] = this.roleId;
        data['roleName'] = this.roleName;
        if (Array.isArray(this.companies)) {
            data['companies'] = [];
            for (const item of this.companies)
                {data['companies'].push(item ? item.toJSON() : undefined as any);}
        }
        if (Array.isArray(this.screens)) {
            data['screens'] = [];
            for (const item of this.screens)
                {data['screens'].push(item ? item.toJSON() : undefined as any);}
        }
        data['hasAllCompanies'] = this.hasAllCompanies;
        data['canImpersonate'] = this.canImpersonate;
        return data;
    }
}

export interface IRoleModel {
    roleId?: number;
    roleName: string;
    companies?: CompaniesModel[] | undefined;
    screens?: ScreensModel[] | undefined;
    hasAllCompanies?: boolean;
    canImpersonate?: boolean;
}

export class ScreensModel implements IScreensModel {
    screenId?: number;
    screenName?: string | undefined;
    isEdit?: boolean;
    isDelete?: boolean;
    isRead?: boolean;
    isCreate?: boolean;
    isApprove?: boolean;
    pemissions?: PemissionsModel[] | undefined;

    constructor(data?: IScreensModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(this as any)[property] = (data as any)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.screenId = _data['screenId'];
            this.screenName = _data['screenName'];
            this.isEdit = _data['isEdit'];
            this.isDelete = _data['isDelete'];
            this.isRead = _data['isRead'];
            this.isCreate = _data['isCreate'];
            this.isApprove = _data['isApprove'];
            if (Array.isArray(_data['pemissions'])) {
                this.pemissions = [] as any;
                for (const item of _data['pemissions'])
                    {this.pemissions?.push(PemissionsModel.fromJS(item));}
            }
        }
    }

    static fromJS(data: any): ScreensModel {
        data = typeof data === 'object' ? data : {};
        const result = new ScreensModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['screenId'] = this.screenId;
        data['screenName'] = this.screenName;
        data['isEdit'] = this.isEdit;
        data['isDelete'] = this.isDelete;
        data['isRead'] = this.isRead;
        data['isCreate'] = this.isCreate;
        data['isApprove'] = this.isApprove;
        if (Array.isArray(this.pemissions)) {
            data['pemissions'] = [];
            for (const item of this.pemissions)
                {data['pemissions'].push(item ? item.toJSON() : undefined as any);}
        }
        return data;
    }
}

export interface IScreensModel {
    screenId?: number;
    screenName?: string | undefined;
    isEdit?: boolean;
    isDelete?: boolean;
    isRead?: boolean;
    isCreate?: boolean;
    isApprove?: boolean;
    pemissions?: PemissionsModel[] | undefined;
}

export class PemissionsModel implements IPemissionsModel {
    permissionId?: number;
    permissionName?: string | undefined;

    constructor(data?: IPemissionsModel) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    {(this as any)[property] = (data as any)[property];}
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data['permissionId'];
            this.permissionName = _data['permissionName'];
        }
    }

    static fromJS(data: any): PemissionsModel {
        data = typeof data === 'object' ? data : {};
        const result = new PemissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['permissionId'] = this.permissionId;
        data['permissionName'] = this.permissionName;
        return data;
    }
}

export interface IPemissionsModel {
    permissionId?: number;
    permissionName?: string | undefined;
}
